/**
 * BDL — POST direto pro Workflow Webhooks (Shopify Flow).
 * fieldOne = origem; fieldTwo = email; fieldThree = nome; fieldFour = respostas.
 *
 * fieldFour tem limite baixo (~2k). HTML compacto com <b>Campo:</b> valor<br>
 * cobre mentoria (todos os steps) e revenda sem truncar.
 */
(function (global) {
  'use strict';

  var SKIP_KEYS = {
    id: true,
    body: true,
    Origem: true,
    Destinatário: true,
    Destinatários: true,
    Captcha: true,
    Website: true
  };

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function stripContactName(name) {
    var match = String(name || '').match(/^contact\[(.*)\]$/);
    return match ? match[1] : String(name || '');
  }

  function prettyKey(key) {
    if (key === 'email') return 'E-mail';
    return key;
  }

  function fieldValue(field) {
    if (field.type === 'checkbox' || field.type === 'radio') {
      return field.checked ? String(field.value || '').trim() : '';
    }
    return String(field.value || '').trim();
  }

  function collectRows(form) {
    var rows = [];
    var seen = {};
    var fields = form.querySelectorAll('input, select, textarea');

    Array.prototype.forEach.call(fields, function (field) {
      var name = field.getAttribute('name') || '';
      if (!name) return;
      if (field.matches('[data-revenda-form-honeypot], [data-mentoria-apply-body-field]')) return;
      if (field.matches('[data-revenda-form-captcha-answer]')) return;
      if (field.type === 'hidden') return;

      var key = stripContactName(name);
      if (!key || SKIP_KEYS[key]) return;

      var value = fieldValue(field);
      if (!value) return;
      if (seen[key]) return;
      seen[key] = true;

      rows.push({
        label: prettyKey(key),
        value: value
      });
    });

    return rows;
  }

  function buildConteudo(origem, form) {
    var rows = collectRows(form);
    var lines = [];

    lines.push('<b>Origem:</b> ' + escapeHtml(origem) + '<br>');
    rows.forEach(function (row) {
      lines.push(
        '<b>' + escapeHtml(row.label) + ':</b> ' + escapeHtml(row.value) + '<br>'
      );
    });

    return lines.join('\n');
  }

  function buildPayload(origem, form) {
    var rows = collectRows(form);
    var email = '';
    var nome = '';

    rows.forEach(function (row) {
      if (!email && (row.label === 'E-mail' || row.label === 'email' || row.label === 'Email')) {
        email = row.value;
      }
      if (!nome && row.label === 'Nome') {
        nome = row.value;
      }
    });

    return {
      fieldOne: origem,
      fieldTwo: email,
      fieldThree: nome,
      fieldFour: buildConteudo(origem, form)
    };
  }

  function post(url, apiKey, payload) {
    if (!url) {
      return Promise.reject(new Error('Webhook URL não configurada'));
    }
    var headers = { 'Content-Type': 'application/json' };
    if (apiKey) headers['X-Api-Key'] = apiKey;

    return fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Falha no envio (' + response.status + ')');
      }
      return response;
    });
  }

  global.BdlFlowWebhook = {
    buildPayload: buildPayload,
    post: post
  };
})(window);
